import BasicImage from 'core/BasicImage';
import BasicLink from 'core/BasicLink';
import FullWrapper from 'core/FullWrapper';
import ScrollAnimation from 'core/ScrollAnimation';
import { sanitize } from 'isomorphic-dompurify';
import React from 'react';

import cn from './style.module.sass';

type NextCaseType = {
    nextCaseImg: string;
    nextCaseTitle: string;
    nextCaseLink: string;
    nextCaseText: string;
};

type NextCaseProps = {
    NextCase: NextCaseType;
};

export default function NextCase({ NextCase }: NextCaseProps) {
    const { nextCaseImg = '', nextCaseTitle, nextCaseLink = '#', nextCaseText } = NextCase;
    return (
        <ScrollAnimation>
            <FullWrapper className={cn.nextCase} isMargin={false}>
                <div className={cn['nextCase__wrapper']}>
                    <BasicLink href={nextCaseLink} className={cn['nextCase__link']}>
                        <BasicImage
                            width={390}
                            height={288}
                            src={nextCaseImg}
                            alt={nextCaseTitle}
                            className={cn['nextCase__image']}
                        />
                    </BasicLink>
                    <div className={cn['nextCase__info']}>
                        <div className={cn['nextCase__over-title']}>Следующий проект</div>
                        <BasicLink href={nextCaseLink} className={cn['nextCase__title']}>
                            <div dangerouslySetInnerHTML={{ __html: sanitize(nextCaseTitle) }} />
                        </BasicLink>

                        <div
                            dangerouslySetInnerHTML={{ __html: sanitize(nextCaseText) }}
                            className={cn['nextCase__text']}
                        />
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
}
